export default __webpack_public_path__ + "static/media/Refer_A_Friend_Scheme_955x660.60906979.jpg";